import { REDUCER_KEY } from "./externalAction.constants";
export var isPerformingExternalActionSelector = function (state, type) {
    return type && state[REDUCER_KEY].externalAction[type]
        ? state[REDUCER_KEY].externalAction[type].isPending
        : false;
};
export var performExternalActionError = function (state, type) {
    return type && state[REDUCER_KEY].externalAction[type]
        ? state[REDUCER_KEY].externalAction[type].error
        : undefined;
};
